import { ReactComponent as Included } from './icon_evidence_in.svg'
import { ReactComponent as Excluded } from './icon_evidence_out.svg'
import { ReactComponent as Raw } from './icon_evidence_raw.svg'
export const EvidenceTabIcons = {
  Included,
  Excluded,
  Raw,
}
